import { render, staticRenderFns } from "./HeaderPda.vue?vue&type=template&id=184e7c96&scoped=true"
import script from "./HeaderPda.vue?vue&type=script&lang=js"
export * from "./HeaderPda.vue?vue&type=script&lang=js"
import style0 from "./HeaderPda.vue?vue&type=style&index=0&id=184e7c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e7c96",
  null
  
)

export default component.exports